import { SquareButton } from '@app/core';
import { Theme } from '@app/theme';
import { AddButton, Input, InputLabel } from 'components';
import { FieldArray, getIn, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme: Theme) => ({
  emailLine: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase,
    marginBottom: theme.marginBase,
  },
  emailInput: {
    flex: 1,
  },
  addButton: {
    border: {
      style: 'solid',
      width: 1,
      color: theme.colors.grayBorder,
    },
  },
}));

interface Props {
  name: string;
  label: string;
}

export const ExtraBillingEmailsField = ({ name, label }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { values } = useFormikContext();

  const emails: string[] = getIn(values, name) || [];

  return (
    <FieldArray name={name}>
      {({ push, remove }) => (
        <div>
          <InputLabel label={label} />
          {emails.map((_, index) => (
            <div className={classes.emailLine} key={index}>
              <Input
                name={`${name}.${index}`}
                type="email"
                containerClass={classes.emailInput}
                noMargin
              />
              <SquareButton
                icon="ri-delete-bin-line"
                color="red"
                onClick={() => remove(index)}
              />
            </div>
          ))}
          <AddButton
            text={t('admin.billing.billingInfo.finalVerification.addEmail')}
            onClick={() => push('')}
            buttonClassName={classes.addButton}
          />
        </div>
      )}
    </FieldArray>
  );
};
